export const CAPTURE_BEHAVIOUR = {
  STEP1: 'registration-1',
  STEP2: 'registration-2',
  STEP3: 'registration-3',
  STEP4: 'registration-4',
};

export const LOCALIZATION_SECTIONS = {
  REGISTRATION_PAGE_1: 'registration-page-1',
  REGISTRATION_PAGE_2: 'registration-page-2',
  REGISTRATION_PAGE_3: 'registration-page-3',
  REGISTRATION_PAGE_4: 'registration-page-4',
  REGISTRATION_UPLOAD_PHOTO: 'registration-upload-photo',
};

export const LANG = {
  RU: 'ru',
  AZ: 'az',
  LV: 'lv',
};

export const IBAN_ACCOUNT_VALUE_LENGTH = 28;
export const EMAIL_CODE_LENGTH = 5;
export const MOBILE_PHONE_LENGTH = 9;
export const SMS_CODE_LENGTH = 4;
export const PASSPORT_ID_MIN_LENGTH = 7;
export const PASSPORT_ID_MAX_LENGTH = 8;
export const NOT_FOUND_CODE = 404;
export const BIRTH_PLACE_TEXT_MAX_LENGTH = 50;

export const iconsEnum = {
  wallet: 'wallet',
  user: 'user',
  document: 'document',
};

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
};

export const accountTypes = {
  card: 'credit_card',
  bank: 'bank_transfer',
};

export const RECOVER_PAGE_SLUG = {
  EMAIL: 'email',
  SMS: 'sms',
};
